import { httpClient } from "../http/httpClient";

export interface Adicional {
  convenioDadosId: number;
  nome: string;
  tipo: number;
  ordem: number;
  formato: string;
}

export interface GetAdditionalFieldsResponse {
  adicionais: Adicional[];
}

export async function getAdditionalFields(id: string, table: string) {
  const { data } = await httpClient.get<GetAdditionalFieldsResponse>(
    `/crefaz/${id}/${table}/fields`,
  );
  return data;
}
